import { BaseUser } from '@lib/core/model';
import { Uuid } from '@lib/core/type';
import { Label } from '@lib/label';

import { UserEntraId } from './user-entra-id';
import { UserLdap } from './user-ldap';

export class User extends BaseUser {
  constructor(
    uuid: Uuid,
    firstName: string,
    lastName: string,
    public readonly username: string,
    email: string,
    public phoneNumber: string,
    public readonly vip: boolean,
    public readonly createdAt: string,
    public readonly account: string,
    public readonly activationExpiresAt: string,
    public readonly superAdmin: boolean,
    public readonly type: string,
    public readonly ldap: UserLdap,
    public readonly entraId: UserEntraId,
    public labels: Label[]
  ) {
    super(null, uuid, firstName, lastName, email);
  }
}
